import { Identidad } from "./identidad.model";

export class Empresa {
  identidad = Identidad.instance();
  digitoVerificador: string;
  razonSocial: string;
  correoElectronico: string

  static instance() {
    return new this();
  }

  static empleadorDesdeObj(obj: object) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: obj["tipoIdEmpleador"] || obj["tipoDocumento"] ,
      numero: obj["idEmpleador"] || obj["numeroDocumento"].slice(0, -1)
    };
    empresaDto.digitoVerificador = obj["digVerifEmpleador"] ?? obj["numeroDocumento"]?.slice(-1);
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = obj["correoEmpleador"] ?? obj["correoElectronico"];
    
    return empresaDto;
  }

  static empleadorDesdeObjRIT(obj: object) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: `${obj["tipoDocumento"]}`,
      numero: `${obj["numeroDocumento"]}`,
    }
    const numeroDocumento = `${obj["numeroDocumento"]}`;
    empresaDto.digitoVerificador = numeroDocumento.slice(-1);
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = `${obj["correoElectronico"]}`;
    return empresaDto;
  }

  static empleadorDesdeObjRBT(obj: object) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: `${obj["tipoDocumento"]}`,
      numero: `${obj["numeroDocumento"]}`,
    }
    const numeroDocumento = `${obj["numeroDocumento"]}`;
    empresaDto.digitoVerificador = numeroDocumento.slice(-1);
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = `${obj["correoElectronico"]}`;
    return empresaDto;
  }

  static empleadorDesdeObjCEC(obj: object, nitEmpresa: string, checkDigit: string) {
    const empresaDto = Empresa.instance();
    empresaDto.identidad = {
      tipo: `${obj["tipoDocumento"]}`,
      numero: nitEmpresa.toString()
    }
    empresaDto.digitoVerificador = checkDigit.toString();
    empresaDto.razonSocial = `${obj["nombre"]}`;
    empresaDto.correoElectronico = `${obj["correoElectronico"]}`;
    return empresaDto;
  }
}
